import { render, staticRenderFns } from "./ModalXLTJ_Gasoline.vue?vue&type=template&id=390fc797&scoped=true&"
import script from "./ModalXLTJ_Gasoline.vue?vue&type=script&lang=js&"
export * from "./ModalXLTJ_Gasoline.vue?vue&type=script&lang=js&"
import style0 from "./ModalXLTJ_Gasoline.vue?vue&type=style&index=0&id=390fc797&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390fc797",
  null
  
)

export default component.exports